
import { UseFormRegister, UseFormSetValue, UseFormWatch } from 'react-hook-form';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';
import { Textarea } from '@/components/ui/textarea';
import type { Application } from '@/types/database.types';

interface RiskQuestionProps {
  id: keyof Application;
  label: string;
  register: UseFormRegister<Partial<Application>>;
  setValue: UseFormSetValue<Partial<Application>>;
  watch: UseFormWatch<Partial<Application>>;
  detailsField?: string;
  detailsPlaceholder?: string;
}

export const RiskQuestion = ({ 
  id, 
  label, 
  register, 
  setValue, 
  watch,
  detailsField,
  detailsPlaceholder = "Please provide details..."
}: RiskQuestionProps) => {
  const value = watch(id) as boolean | undefined;
  
  const handleChange = (checked: boolean) => {
    setValue(id, checked);
  };

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between">
        <Label htmlFor={id as string} className="font-medium text-foreground">
          {label}
        </Label>
        <Switch
          id={id as string}
          checked={value === true}
          onCheckedChange={handleChange}
        />
      </div>
      
      {value && detailsField && (
        <div className="pl-5 border-l-2 border-primary/20 mt-2">
          <Textarea
            id={detailsField}
            {...register(detailsField as any)} 
            placeholder={detailsPlaceholder}
            className="mt-1"
          />
        </div>
      )}
    </div>
  );
};
